// extracted by mini-css-extract-plugin
export default {"slider_img":"SliderImage_slider_img__KzwOx","slider_con":"SliderImage_slider_con__LLz5D","carousellStyle":"SliderImage_carousellStyle__6IY4p"};